import styles from './Builder.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { FormBuilderContext } from '../../../store/store.FormBuilder'
import Page from './Page/Page'

const Builder = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)
  return (
    <div className={styles.content}>
      <div className={styles.content_pages}>
        {storeFormBuilder.pages.map((pageStore, index) => (
          <Page key={index} pageStore={pageStore} />
        ))}
      </div>
    </div>
  )
})

export default Builder
